export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0024s_0000_Black-&-White-24.8e1bf46a.png";